import {CommonService} from "../common/common.service";
import {CommonDataService} from "../common/common-data.service";
import {Injectable} from "@angular/core";
import {Constants} from "../common/constants";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {Mailbox} from "./mailbox";
import {FormGroup} from "@angular/forms";
import { MailboxRequest } from './mailbox-request';

@Injectable()
export class ManageMailboxService {

  constructor(private commonService: CommonService, private commonDataService: CommonDataService, private router: Router, private httpClient: HttpClient) {}

  getMailBoxServices(): Observable<Mailbox[]> {
    return this.httpClient.get<Mailbox[]>(`/api/mailbox/getMailboxList/${this.commonDataService.user.billingAccountId}`);
  }

  getMailBoxDetails(emailAddress: string): Observable<Mailbox> {
    return this.httpClient.get<Mailbox>(`/api/mailbox/getMailboxSettings/${this.commonDataService.user.billingAccountId}/${emailAddress}`);
  }

  updateMailBoxSettings(mailboxDetails: Mailbox): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    return this.httpClient.post<any>('/api/mailbox/modifyMailBoxSettings', mailboxDetails);
  }

  checkUsernameUnique(username: string): Observable<boolean>{
    return this.httpClient.get<boolean>('/api/mailbox/checkUsernameUnique/' + username);
  }

/*  addMailbox(mailboxRequest: MailboxRequest): Observable<string> {
    let headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    return this.httpClient.post<string>('/api/mailbox/addMailbox', mailboxRequest);
  }*/

  deleteMailbox(mailboxRequest: MailboxRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    return this.httpClient.post<any>('/api/mailbox/removeMailbox', mailboxRequest);
  }
}
